// NO PRICE SURPRISES (17 Oct 2026). The large-car and same-day charges as
// their own lines wherever the total shows: the total above the pay buttons,
// the phone bar, and (the size) beside the wash's price. Replays: a size
// carried over from an earlier visit (£95 on the card, £115 at pay), Large
// +£20 tapped just before leaving, Today +£25 then gone 16 s later
// (replays-ios-2026-10-17.md, pattern 3).
//
// Pure, so it runs under node --test (price-lines.test.mjs). Amounts come in
// already written as the site writes prices ("£20", lib/use-live-price.js).
import { SAME_DAY_LABEL } from './same-day-offer.js'

// The same-day line says "Same-day priority" (17 Oct 2026, lib/same-day-offer.js).
export const SURCHARGE_LABELS = { large_car: 'Large car', same_day: SAME_DAY_LABEL }

// [{ key, label, amount: '+£20' }] for each charge that applies, in this
// order: large car, then same day. A charge whose price is not known yet is
// left out rather than shown as "+".
export const surchargeLines = ({ largeCar = null, sameDay = null } = {}) => [
  largeCar && { key: 'large_car', label: SURCHARGE_LABELS.large_car, amount: `+${largeCar}` },
  sameDay && { key: 'same_day', label: SURCHARGE_LABELS.same_day, amount: `+${sameDay}` }
].filter(Boolean)

// "Large car +£20 · Same-day priority +£25", for the one line the phone bar has.
export const surchargeText = lines => (lines || []).map(l => `${l.label} ${l.amount}`).join(' · ')

// "Large car +£20", the line under a wash card's price (19 Oct 2026,
// docs/DECISIONS.md): the surcharge before the wash is picked, not only at
// the total. No amount, no line.
export const largeCarLine = amount => amount && `${SURCHARGE_LABELS.large_car} +${amount}`

// The price on the booking events (ANALYTICS.md "Price on the booking
// events", 19 Oct 2026). state: the store's { services, prices }; ids:
// { large_car, same_day, congestion_zone } service ids; size: a size just
// picked, ahead of the store. total_pence is the selected services as
// listed (wash, extras, surcharges; before any code, credit or tip); size is
// null until one is picked (the store holds the large car as true, false or
// null). Before the catalogue has loaded the surcharge ids are undefined, and
// the store's services["undefined"] (written by setCongestionZone(false) and
// friends) must not read as the large car: size stays null (CI run
// 39252053915 sent "small" on every section viewed before the list landed).
export const priceProps = ({ services = {}, prices = {} } = {}, ids = {}, size) => {
  const known = ids.large_car != null
  const chosen = size && known ? { ...services, [ids.large_car]: size === 'large' } : services
  const large = size ? size === 'large' : known ? chosen[ids.large_car] : null
  return {
    total_pence: Object.keys(chosen).reduce((sum, id) => sum + ((chosen[id] && Number(prices.byId?.[id]?.customerPriceCents)) || 0), 0) || null,
    size: large ? 'large' : large === false ? 'small' : null,
    surcharges: Object.keys(ids).filter(key => ids[key] != null && chosen[ids[key]])
  }
}
